module.exports = __webpack_public_path__ + "img/Sunglasses02.839bc49c.png";